import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/Fraport_Logo_Slovenija.svg'


const _hoisted_1 = { class: "p-4 border-b border-sidebar-border flex items-center justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "text-xl font-semibold text-center"
}
const _hoisted_3 = {
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 5l7 7-7 7M5 5l7 7-7 7"
}
const _hoisted_5 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
}
const _hoisted_6 = { class: "mt-5 flex-grow" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "mb-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "mt-auto border-t border-sidebar-border p-4" }
const _hoisted_24 = {
  key: 0,
  class: "text-sm font-semibold text-primary"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 0,
  class: "flex-1 min-w-0"
}
const _hoisted_27 = { class: "text-sm font-medium truncate" }
const _hoisted_28 = { class: "text-xs text-sidebar-foreground/70 truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-full bg-sidebar text-sidebar-foreground transition-all duration-300 flex-shrink-0 flex flex-col", [_ctx.isCollapsed ? 'w-16' : 'w-64']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center justify-center", [_ctx.isCollapsed ? 'w-full' : 'mb-2']])
      }, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Fraport Slovenija Logo",
              class: "h-12 w-auto"
            }, null, -1)
          ])),
          _: 1
        })
      ], 2),
      (!_ctx.isCollapsed)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Navigation"))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args))),
        class: "p-1 rounded-md hover:bg-sidebar-accent transition-colors duration-200"
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
          (_ctx.isCollapsed)
            ? (_openBlock(), _createElementBlock("path", _hoisted_4))
            : (_openBlock(), _createElementBlock("path", _hoisted_5))
        ]))
      ])
    ]),
    _createElementVNode("nav", _hoisted_6, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'dashboard', 'justify-center': _ctx.isCollapsed }])
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                }, null, -1)
              ]), 2)),
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Dashboard"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/email-generator",
            class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'email-generator', 'justify-center': _ctx.isCollapsed }])
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                }, null, -1)
              ]), 2)),
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Email Generator"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        (_ctx.userData?.business_role === _ctx.BusinessRole.PLANNER)
          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/forecasting-planners",
                class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'forecasting-planners', 'justify-center': _ctx.isCollapsed }])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    }, null, -1)
                  ]), 2)),
                  (!_ctx.isCollapsed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Forecasting for Planners"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.userData?.business_role === _ctx.BusinessRole.HEAD_OF_PCO || _ctx.userData?.business_role === _ctx.BusinessRole.CONTROLLER)
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: "/forecasting-pco",
                class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'forecasting-pco', 'justify-center': _ctx.isCollapsed }])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    }, null, -1)
                  ]), 2)),
                  (!_ctx.isCollapsed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Forecasting for PCO"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.userData?.business_role === _ctx.BusinessRole.HEAD_OF_PCO)
          ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: "/administration",
                class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'administration', 'justify-center': _ctx.isCollapsed }])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                    }, null, -1),
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    }, null, -1)
                  ]), 2)),
                  (!_ctx.isCollapsed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Administration"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_17, [
          _createVNode(_component_router_link, {
            to: "/supabase-test",
            class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'supabase-test', 'justify-center': _ctx.isCollapsed }])
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[9] || (_cache[9] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                }, null, -1)
              ]), 2)),
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "[REMOVE] Supabase Test"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", _hoisted_19, [
          _createVNode(_component_router_link, {
            to: "/storage-test",
            class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'storage-test', 'justify-center': _ctx.isCollapsed }])
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                }, null, -1)
              ]), 2)),
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "[REMOVE] Storage Test"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", _hoisted_21, [
          _createVNode(_component_router_link, {
            to: "/template-storage",
            class: _normalizeClass(["flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200", { 'bg-sidebar-accent': _ctx.activeItem === 'template-storage', 'justify-center': _ctx.isCollapsed }])
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-5 w-5", [_ctx.isCollapsed ? '' : 'mr-3']]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }, null, -1)
              ]), 2)),
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "[REMOVE] Template Storage"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center", { 'justify-center': _ctx.isCollapsed }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center overflow-hidden", [_ctx.isCollapsed ? '' : 'mr-3']])
        }, [
          (!_ctx.userData || !_ctx.userData.avatar)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.userInitials), 1))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.userData.avatar,
                alt: "User avatar",
                class: "h-full w-full object-cover"
              }, null, 8, _hoisted_25))
        ], 2),
        (!_ctx.isCollapsed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.userData?.business_role ? _ctx.formatBusinessRole(_ctx.userData.business_role as BusinessRole) : 'Not set'), 1),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.userData?.name), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isCollapsed)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/user-settings",
              class: "ml-2 p-2 rounded-md hover:bg-sidebar-accent transition-colors duration-200 flex items-center justify-center",
              title: "Settings"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5 text-sidebar-foreground/70",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  })
                ], -1)
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isCollapsed)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
              class: "ml-2 p-2 rounded-md hover:bg-sidebar-accent transition-colors duration-200 flex items-center justify-center",
              title: "Logout"
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                })
              ], -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.isCollapsed)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
              class: "mt-2 p-2 rounded-md hover:bg-sidebar-accent transition-colors duration-200 flex items-center justify-center",
              title: "Logout"
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                })
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 2))
}